import { MessageResponseDto, PersonApiFp } from "@api/api";
import { useNotificationContext } from "@shared/ui/notification/notification.context";
import { useMutation, useQueryClient } from "react-query";
import { authHeaders } from "./auth-header";
import { QueryKey } from "./query-key.enum";
import { AxiosError } from "axios";
import { getApiErrorMessage } from "@core/utility/get-error-message";
import { useSessionContext } from "./session.context";
import { CreatePersonModel } from "@core/model/query-model-person";

// POST Query
export function useQyAddEmployee(
  onSuccess?:
    | ((data: MessageResponseDto) => void | Promise<unknown>)
    | undefined,
  onError?: ((error: unknown) => void | Promise<unknown>) | undefined
) {
  const { checkSession } = useSessionContext();
  const queryClient = useQueryClient();
  const { showProgress, hideProgress, showError } = useNotificationContext();

  const apiFn = async (payload: CreatePersonModel) => {
    await checkSession();

    showProgress();
    const operation = await PersonApiFp().personControllerCreate(
      payload,
      undefined, //file
      authHeaders()
    );
    const response = (await operation()).data;
    return response as MessageResponseDto;
  };

  return useMutation({
    mutationFn: apiFn,
    onSuccess: (response) => {
      hideProgress();
      queryClient.invalidateQueries(QueryKey.Person);
      if (onSuccess) {
        onSuccess(response);
      }
    },
    onError: (err: AxiosError) => {
      hideProgress();
      const message = getApiErrorMessage(err);
      showError(message);

      if (onError) {
        onError(err);
      }
    },
    onSettled() {
      hideProgress();
    },
  });
}
